export default {
  en: {
    copyright: 'The copyright of this event belongs to App',
    timeR: 'Count down:',
    timeR2: ' before the activity starts ',
    rank: 'Ranking',
    toptitle: 'KSA National Day',
    title: 'Celebration KSA',
    ruleDes:
      'To celebrate KSA National Day, we will be holding events from September 23rd to 30th. During the event, users send the following gifts, and the winner can get rewards',
    nav1: 'Last Week',
    nav2: 'This Week',
    rule: 'Rules',
    share: 'Reward',
    rulePop:
      'Activity time: 2022.09.23-2022.09.30<br/>1. The ranking is based on the coins of gift sent.<br/>2. Top 3 in every ranking can only have one piece of reward.<br/>3.If the user is top 3 in both rankings, he will be awarded according world ranking.<br/>4. This activity is irrelavant with Apple Company.<br/>5: This event includes two categories:<br/>KSA category: upgrade only through Saudi gifts in the event (<br/>World ranking: upgrade through world gifts)',
    world: 'Sender',
    country: 'Receiver',
    notice: 'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'days'
  },
  ar: {
    copyright: 'The copyright of this event belongs to App',
    timeR: 'العد التنازلي :',
    timeR2: 'قبل بدء النشاط',
    rank: 'التصنيف',
    toptitle: 'إحتفال السعودية',
    title: 'إحتفال السعودية',
    ruleDes:
      'للاحتفال باليوم الوطني للمملكة العربية السعودية ، سنعقد فعاليات من 23 إلى 30 سبتمبر.  خلال الحدث ، يرسل المستخدمون الهدايا التالية ، ويمكن للفائز الحصول على مكافآت',
    nav1: 'الأسبوع الماضي',
    nav2: ' هذا الاسبوع',
    rule: 'القواعد',
    share: 'مكافأة',
    rulePop:
      'وقت النشاط: 2022.09.23-2022.09.30<br/>1. يعتمد الترتيب على عملات الهدية المرسلة.<br/>2. يمكن أن تحصل المراكز الثلاثة الأولى في كل تصنيف على قطعة واحدة فقط من المكافأة.<br/>3. إذا كان المستخدم هو الأول في كلا الترتيبين ، فسيتم تكريمه وفقًا للترتيب العالمي.<br/>4. هذا النشاط غير مهم مع شركة Apple.<br/>5: يتضمن هذا الحدث تصنيفين : <br/> - التصنيف السعودي :  يتم ترقيته بواسطة هدايا السعودية التي في الحدث فقط ( ksa gift ) <br/>- التصنيف العالمي : يتم ترقيته بواسطة هدية العالم ( world gift )',
    world: 'المستلم',
    country: 'مكافأة الرتبة',
    notice: 'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'أيام'
  },
  tr: {
    copyright: 'The copyright of this event belongs to App',
    timeR: 'Kalan Süre: ',
    timeR2: ' before the activity starts ',
    rank: 'Sıralama',
    toptitle: 'Suudi Arabistan Ulusal Günü',
    title: 'Kutlama Suudi Arabistan',
    ruleDes:
      "KSA Ulusal Günü'nü kutlamak için 23-30 Eylül tarihleri arasında etkinlikler düzenleyeceğiz. Etkinlik sırasında kullanıcılar aşağıdaki hediyeleri gönderir ve kazanan ödül alabilir",
    nav1: 'Geçen Hafta',
    nav2: 'Bu Hafta',
    rule: 'Kurallar',
    share: 'Ödül',
    rulePop:
      "Faaliyet zamanı: 2022.09.23-2022.09.30<br/>1. Sıralama, gönderilen hediye paralarına göre yapılır.<br/>2. Her sıralamada ilk 3'e sadece bir parça ödül verilebilir.<br/>3.Kullanıcı her iki sıralamada da ilk 3'teyse, dünya sıralamasına göre ödüllendirilecektir.<br/>4. Bu aktivitenin Apple Company ile ilgisi yoktur.",
    world: 'İtibar',
    country: 'Ünlü',
    notice: 'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'gün'
  },
  pt: {
    copyright: 'O direito autoral deste evento pertence ao App',
    timeR: 'Contagem regressiva:',
    timeR2: ' antes do início da atividade ',
    rank: 'Classificação',
    toptitle: 'Dia Nacional da Arábia Saudita',
    title: 'Celebração da Arábia Saudita',
    ruleDes:
      'Para celebrar o Dia Nacional da Arábia Saudita, realizaremos eventos de 23 a 30 de setembro. Durante o evento, os usuários enviarão os seguintes presentes, e o vencedor poderá ganhar recompensas',
    nav1: 'Última Semana',
    nav2: 'Esta Semana',
    rule: 'Regras',
    share: 'Recompensa',
    rulePop:
      'Tempo da atividade: 2022.09.23-2022.09.30<br/>1. A classificação é baseada nas moedas dos presentes enviados.<br/>2. Os 3 primeiros em cada classificação podem receber apenas uma recompensa.<br/>3. Se o usuário ficar entre os 3 primeiros nas duas classificações, ele será premiado de acordo com a classificação mundial.<br/>4. Esta atividade não tem relação com a Apple Company.<br/>5: Este evento inclui duas categorias:<br/>Categoria KSA: atualização apenas através de presentes sauditas no evento (<br/>Classificação mundial: atualização através de presentes mundiais)',
    world: 'Remetente',
    country: 'Receptor',
    notice: 'Se o país da sua conta for alterado durante a atividade, sua classificação de troféu será limpa.',
    days: 'dias'
  },
  id: {
    copyright: 'Hak cipta acara ini milik App',
    timeR: 'Hitung mundur:',
    timeR2: ' sebelum aktivitas dimulai ',
    rank: 'Peringkat',
    toptitle: 'Hari Nasional KSA',
    title: 'Perayaan KSA',
    ruleDes:
      'Untuk merayakan Hari Nasional KSA, kami akan mengadakan acara dari 23 hingga 30 September. Selama acara, pengguna akan mengirimkan hadiah berikut, dan pemenang dapat mendapatkan hadiah',
    nav1: 'Minggu Lalu',
    nav2: 'Minggu Ini',
    rule: 'Aturan',
    share: 'Hadiah',
    rulePop:
      'Waktu aktivitas: 2022.09.23-2022.09.30<br/>1. Peringkat didasarkan pada koin hadiah yang dikirim.<br/>2. Tiga teratas di setiap peringkat hanya dapat memiliki satu hadiah.<br/>3. Jika pengguna berada di tiga teratas di kedua peringkat, ia akan diberikan hadiah sesuai dengan peringkat dunia.<br/>4. Aktivitas ini tidak ada hubungannya dengan Apple Company.<br/>5: Acara ini mencakup dua kategori:<br/>Kategori KSA: peningkatan hanya melalui hadiah Saudi dalam acara (<br/>Peringkat dunia: peningkatan melalui hadiah dunia)',
    world: 'Pengirim',
    country: 'Penerima',
    notice: 'Jika negara akun Anda berubah selama aktivitas, peringkat trofi Anda akan dibersihkan.',
    days: 'hari'
  },
  uz: {
    copyright: 'Ushbu tadbirning mualliflik huquqi App-ga tegishli',
    timeR: 'Qoldiq:',
    timeR2: ' faoliyat boshlanishidan oldin ',
    rank: 'Reyting',
    toptitle: 'KSA Milliy Kuni',
    title: 'KSA Bayrami',
    ruleDes:
      "KSA Milliy Kunini nishonlash uchun biz 23-sentabrdan 30-sentabrgacha tadbirlar o'tkazamiz. Tadbir davomida foydalanuvchilar quyidagi sovg'alarni yuboradilar, va g'olib mukofotlar oladi",
    nav1: "O'tgan Hafta",
    nav2: 'Bu Hafta',
    rule: 'Qoidalar',
    share: 'Mukofot',
    rulePop:
      "Faoliyat vaqti: 2022.09.23-2022.09.30<br/>1. Reyting yuborilgan sovg'a tanga miqdoriga asoslangan.<br/>2. Har bir reytingdagi eng yuqori 3 kishi faqat bitta mukofot olishlari mumkin.<br/>3. Agar foydalanuvchi ikkala reytingda ham eng yaxshi 3-likda bo'lsa, unga dunyo reytingiga qarab mukofot beriladi.<br/>4. Bu tadbir Apple kompaniyasi bilan bog'liq emas.<br/>5: Bu tadbir ikkita kategoriyani o'z ichiga oladi:<br/>KSA kategoriyasi: faqat Saudi sovg'alar orqali yangilanish (<br/>Dunyo reytingi: dunyo sovg'alar orqali yangilanish)",
    world: "Jo'natuvchi",
    country: 'Qabul qiluvchi',
    notice: "Agar hisobingizning mamlakati faoliyat davomida o'zgarsa, sizning kubok reytingingiz tozalanadi.",
    days: 'kun'
  },
  ru: {
    copyright: 'Авторские права на это мероприятие принадлежат App',
    timeR: 'Обратный отсчет:',
    timeR2: ' до начала мероприятия ',
    rank: 'Рейтинг',
    toptitle: 'Национальный день Саудовской Аравии',
    title: 'Празднование Саудовской Аравии',
    ruleDes:
      'В честь Национального дня Саудовской Аравии мы проведем мероприятия с 23 по 30 сентября. Во время мероприятия пользователи отправляют следующие подарки, и победитель может получить награды',
    nav1: 'Прошлая неделя',
    nav2: 'Эта неделя',
    rule: 'Правила',
    share: 'Награда',
    rulePop:
      'Время мероприятия: 2022.09.23-2022.09.30<br/>1. Рейтинг основывается на монетах подарков.<br/>2. Топ-3 в каждом рейтинге могут получить только один подарок.<br/>3. Если пользователь находится в топ-3 в обоих рейтингах, он получит награду в соответствии с мировым рейтингом.<br/>4. Это мероприятие не связано с Apple.<br/>5: Это событие включает две категории:<br/>Категория KSA: обновление только через подарки Саудовской Аравии (<br/>Мировой рейтинг: обновление через мировые подарки)',
    world: 'Отправитель',
    country: 'Получатель',
    notice: 'Если страна вашей учетной записи изменится во время мероприятия, ваш рейтинг кубка будет очищен.',
    days: 'дни'
  },
  fa: {
    copyright: 'حق چاپ این رویداد متعلق به اپ است',
    timeR: 'شمارش معکوس:',
    timeR2: ' قبل از شروع فعالیت ',
    rank: 'رتبه بندی',
    toptitle: 'روز ملی KSA',
    title: 'جشن KSA',
    ruleDes:
      'برای جشن گرفتن روز ملی KSA، از 23 تا 30 سپتامبر رویدادهایی را برگزار خواهیم کرد. در طول رویداد، کاربران هدایا زیر را ارسال می کنند و برنده می تواند جوایزی دریافت کند',
    nav1: 'هفته گذشته',
    nav2: 'این هفته',
    rule: 'قوانین',
    share: 'پاداش',
    rulePop:
      'زمان فعالیت: 2022.09.23-2022.09.30<br/>1. رتبه بندی بر اساس سکه های هدیه ارسال شده است.<br/>2. سه نفر اول در هر رتبه بندی فقط می توانند یک پاداش دریافت کنند.<br/>3. اگر کاربر در هر دو رتبه بندی جزو سه نفر اول باشد، جوایزی مطابق با رتبه جهانی دریافت خواهد کرد.<br/>4. این فعالیت هیچ ارتباطی با شرکت Apple ندارد.<br/>5: این رویداد شامل دو دسته است:<br/>دسته KSA: تنها از طریق هدایای سعودی در رویداد ارتقاء پیدا می کند (<br/>رتبه بندی جهانی: ارتقاء از طریق هدایای جهانی)',
    world: 'فرستنده',
    country: 'گیرنده',
    notice: 'اگر کشور حساب شما در طول فعالیت تغییر کند، رتبه بندی جام شما پاک خواهد شد.',
    days: 'روز'
  },
  ur: {
    copyright: 'اس ایونٹ کا جملہ حقوق ایپ کے پاس محفوظ ہیں',
    timeR: 'الٹی گنتی:',
    timeR2: ' سرگرمی شروع ہونے سے پہلے ',
    rank: 'درجہ بندی',
    toptitle: 'سعودی قومی دن',
    title: 'سعودی عرب کی تقریبات',
    ruleDes:
      'سعودی قومی دن منانے کے لیے، ہم 23 سے 30 ستمبر تک ایونٹس منعقد کریں گے۔ ایونٹ کے دوران، صارفین درج ذیل تحائف بھیجیں گے، اور فاتح انعامات حاصل کر سکتا ہے',
    nav1: 'پچھلا ہفتہ',
    nav2: 'اس ہفتہ',
    rule: 'قواعد',
    share: 'انعام',
    rulePop:
      'سرگرمی کا وقت: 2022.09.23-2022.09.30<br/>1. درجہ بندی بھیجے گئے تحائف کے سکوں کی بنیاد پر ہوگی۔<br/>2. ہر درجہ بندی میں ٹاپ 3 کو صرف ایک انعام مل سکتا ہے۔<br/>3. اگر صارف دونوں درجہ بندیوں میں ٹاپ 3 میں ہے، تو اسے عالمی درجہ بندی کے مطابق انعام دیا جائے گا۔<br/>4. یہ سرگرمی ایپل کمپنی سے متعلق نہیں ہے۔<br/>5: اس ایونٹ میں دو اقسام شامل ہیں:<br/>سعودی عرب کیٹیگری: صرف ایونٹ میں سعودی تحائف کے ذریعے اپ گریڈ<br/>عالمی درجہ بندی: عالمی تحائف کے ذریعے اپ گریڈ',
    world: 'بھیجنے والا',
    country: 'وصول کنندہ',
    notice: 'اگر سرگرمی کے دوران آپ کے اکاؤنٹ کا ملک تبدیل ہو جاتا ہے، تو آپ کی ٹرافی درجہ بندی صاف کر دی جائے گی۔',
    days: 'دن'
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly/lang.js